import { Component, OnInit, Input } from '@angular/core';
import { AdminDispatcher } from '../../../store/admin-store/admin-dispatcher';
import { SidenavService } from '../../services/sidenav.service';
import { Customer } from '../customer.model';
import { MatMiniFabButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-advanced-features',
    templateUrl: './advanced-features.component.html',
    styleUrls: ['./advanced-features.component.scss'],
    imports: [MatMiniFabButton, MatIcon, NgIf, MatButton, TranslatePipe]
})
export class AdvancedFeaturesComponent implements OnInit {
  /**
   * @property Property to store customer information
   */
  @Input() customer: Customer;
  /**
   *
   * @property Property to store expanded feature
   */
  public expanded: boolean;

  constructor(
    private adminDispatcher: AdminDispatcher,
    private sidenav: SidenavService,
  ) {
    this.expanded = false;
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit() {
  }

  /**
   * @method toggleSidenav toggles the side nav
   **/
  public toggleSidenav(updateAttribute: string): void {
    let _value: any;
    window.scroll(0, 0);
    if (updateAttribute === 'delete') {
      _value = this.customer;
    }

    this.adminDispatcher.setUpdateInfo('account', updateAttribute, _value, this.customer['lastUpdateDate']);
    this.sidenav.toggle();
  }

  /**
   * @function expandAdvancedFeatures changes the value of expanded to show advanced features
   */
  public expandAdvancedFeatures(): void {
    this.expanded = !this.expanded;
  }
}
